import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./app/App";

// console.log('Start APP', process.env.REACT_APP_PROJECT);

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);
